import { getLocale, isSupportedLocale } from './getLocale'
import { getLocaleFromUtmSource } from './getLocaleFromUtmSource'

type TResolveRootLocaleParams = {
  userLang?: TLocale | null
  utmSource?: string | null
  storedLocale?: TLocale
}

export const resolveRootLocale = ({ userLang, utmSource, storedLocale }: TResolveRootLocaleParams): TLocale => {
  const browserLocale = getLocale()
  const supportedBrowserLocale = isSupportedLocale(browserLocale) ? browserLocale : undefined
  const utmLocale = getLocaleFromUtmSource(utmSource)

  return userLang ?? utmLocale ?? storedLocale ?? supportedBrowserLocale ?? 'en'
}
